<template>
  <div class="yong-block  bg-white w-100">
    <div class="product-item container">
      <div class="item-title text-center  pt-5">{{title}}</div>
      <div class="item-content" v-if="yongProList">
        <div v-for="(item, index) in yongProList" :key="item.id">
          <div>
            <van-card class=" yong-item p-3" @click="gotoPage(item)">
              <template #title>
                <div class="yong-item-title">
                  <span class="mr-2">{{index+1}}</span>
                  {{item.title}}
                </div>
              </template>
              <template #desc>
                <p class="desc van-multi-ellipsis--l3">
                  {{item.summary}}
                </p>
              </template>
            </van-card>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Card} from 'vant';
  import {List} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Card);
  Vue.use(List);

  export default {
    name: "yongComponent",
    data() {
      return {}
    },
    props: [
      'yongProList',
      'title'
    ],
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        ContentTypeEnum: state => state.ContentTypeEnum
      })
    },
    methods: {
      gotoPage(item) {
        if (item.contentType === this.ContentTypeEnum.PROJECT.value
          || item.contentType === this.ContentTypeEnum.COURSE.value) {
          this.$router.push('/'+item.contentType+'/'+item.content);
        }
        if (item.contentType === this.ContentTypeEnum.USER.value) {
          this.$router.push('/lecturer/'+item.content);
        }
        if (item.contentType === this.ContentTypeEnum.NEWS.value) {
          this.$router.push('/news-detail/'+item.id);
        }
        if (item.contentType === this.ContentTypeEnum.LINK.value) {
          window.open(item.linkUrl);
        }
      }
    }
  }
</script>

<style scoped>
  .van-card__content {
    position: static;
  }
</style>
